import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext } from 'react';
import UserGoBack from "../../user/UserGoBack";
import CardHelpLink from "../CardHelpLink";
import RightPartContent from "../RightPartContent";
import { useGetAllTopicsQuery } from "../../../slices/topicsApiSlice";
import LoaderAccessRapide from "../../skeletons/LoaderAccessRapide";

const AccesRapide = ({ goBackLinks, guideInfo, img, content, topicsIds }) => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { data: topics, isLoading } = useGetAllTopicsQuery();

  if (isLoading) return <LoaderAccessRapide />

  const isSmallDevise = windowWidth < 900;

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={guideInfo} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <img src={img} className="help-img border-light"/>
            {content}
            {topics.filter(article => topicsIds.includes(article.id_topic)).map((article, index) => {
              return (
                <CardHelpLink key={index}
                  title={article.title} link={article.link} slug={article.slug}
                  slugClass='fw-600 fz-14 mb-8 op-7' description={article.description}
                  containerClass={`help-link-container`} titleClass="help-link-text" descriptionClass="help-description fz-14 op-7" 
                />
              )
            })}
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default AccesRapide